const hotelv1 = '/hotel/'
const hotelv2 = '/hotelv2/'
const securityv1 = '/securityv1'
const securityv2 = '/securityv2/'
const vghotelv1 = '/vghotelv1/'
const userv2 = '/userv2/'
const userv3 = '/userv3/'
const userv5 = '/userv5/'
const vguserv1 = '/vguserv1/'
const vguserv2 = '/vguserv2/'
const broadcastv1 = '/broadcastv1/'
const broadcastv2 = '/broadcastv2/'
const entryv1 = '/entryv1/'
const supportv1 = '/supportv1/'

export default {
  Supportv1: supportv1,
  Hotelv1: hotelv1,
  Hotelv2: hotelv2,
  Securityv1: securityv1,
  Securityv2: securityv2,
  Vghotelv1: vghotelv1,
  Userv2: userv2,
  Userv3: userv3,
  Userv5: userv5,
  Vguserv1: vguserv1,
  Vguserv2: vguserv2,
  Broadcastv1: broadcastv1,
  Broadcastv2: broadcastv2,
  Entryv1: entryv1
}
